import { MultiPartField, multiPartSchema } from './MultiPartField';
import type { FieldPart, FormFieldComponent } from './types-reexport';

const PARTS: readonly FieldPart[] = [
  { role: 'postalCodeFormField', fallbackName: 'postalCode' },
  { role: 'houseNumberFormField', fallbackName: 'houseNumber' },
  { role: 'houseNumberSuffixFormField', fallbackName: 'houseNumberSuffix' },];

const GenericFormAddressField: FormFieldComponent = () => <MultiPartField parts={PARTS} />;

GenericFormAddressField.formSchema = content => multiPartSchema(content, PARTS);

export default GenericFormAddressField;
